import React, {  useCallback } from "react";
import {  useSelector } from "react-redux";
import { Button, Form, Icon } from "semantic-ui-react";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import { CustomLoader } from "../../../commonComponents/formComponents/loader";
import ExitInformationDetails from "./exitInformationDetails";
import { useDocument } from "../../hooks/useDocument";
import PopUpIcon from "../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../TranslateContext";

const ExitInformation = ({disabled,exitInfoCurrentStatus,isDMS}) => {
  const {isLoading,AddItem,deleteItem,updateItem,saveItem}=useDocument({actionType:"HEADER",tableName:"exitInformation",containerKey:"header"})
  const exitInfoDs = useSelector((state) => state.Shipment.exitInformation);
  const exitInfoList = useSelector((state) => state.DropDownValues.exitInfo);
  const translate = React.useContext(TranslateContext).translate

  const ValidateExitInfo=useCallback((selectedValue,id)=>{
     if(!selectedValue?.trim() || exitInfoList.find(c=>c.id==selectedValue)?.type?.toUpperCase()!="AAZ") //  if selected type is not AAZ then skip condition
          return false
          
      // select all updated exit Information
     const selectedExitInfoIds=exitInfoDs.reduce((prev,curr)=>{
        if(!curr.exitInfo?.trim() || id==curr.id) return prev
        return {...prev,[`${curr.exitInfo}`]:true}
     },{})
    
     // check if AAZ already exists
    
    return exitInfoList.some(({id,type})=>(selectedExitInfoIds[id]  && type?.toUpperCase()=="AAZ"))
     
    },[exitInfoDs,exitInfoList])
  
  const renderItem=useCallback((item)=>{
    return <ExitInformationDetails
    key={item.id}
    item={item}
    disabled={disabled}
    updateData={updateItem}
    deleteData={deleteItem}
    saveData={saveItem}
    validateExitInfo={ValidateExitInfo}
    exitInfoList={exitInfoList}
    />
   },[updateItem,deleteItem,disabled,ValidateExitInfo,exitInfoList])
  
  
  return (
  
    <Form.Group className="float-container">
         
         <FormTitle title={translate("EXIT_INFORMATION", {ns:["default", "header"]})}></FormTitle>
        <List 
          dataSource={exitInfoDs}
          renderItem={renderItem}
        />
  
      { isLoading && <CustomLoader /> }
      {
        exitInfoDs?.length<(isDMS ? 10 : 1) 
        && <Button 
            basic
            color="blue"
            className="btn-add-item"
            id={`exitInfo-add`}
            disabled={disabled} 
            onClick={AddItem} 
            >
              <span><Icon name="add circle" /></span>
              {translate("ADD")}

      </Button>
} 
     
      </Form.Group>
   
  );
}

export default React.memo(ExitInformation)
